//imported some common vendor files; which were previously processed by grunt
//this can help to get rid on grunt; and unify build process with webpack only
//slowly moving from grunt to webpack

//some files here are imported by full paths
//see webpack.config aliases for detials
//without full path library don't work with webpack or current code
import 'jquery';
import 'jquery-migrate';
import 'bootstrap';
export { default as moment } from 'moment';
import 'moment/locale/it.js';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-validation/dist/localization/messages_it.js';
export { default as store } from 'store';
import 'select2';
import 'select2/select2_locale_it.js';
import 'eonasdan-bootstrap-datetimepicker';
import 'datatables.net';
import 'drmonty-datatables-colvis';
import 'datatables.net-colreorder';
import 'datatables.net-plugins/pagination/input.js';
import 'datatables.net-plugins/pagination/select.js';
export { default as toastr } from 'toastr';
export { default as purl } from 'purl';
import 'bootstrap-3-typeahead';
import 'inputmask';

//this are for commons-global-entrypoint to not depend on es6-vendor
export { default as sha1 } from 'js-sha1';
export { default as EventEmitter } from 'eventemitter3';
